module.exports = __webpack_public_path__ + "static/media/icon-pets.4091f425.png";